module.exports = __webpack_public_path__ + "img/LOGO VERSIÓN FINAL NQA.acd41f14.png";